import React from "react"

import {
  EmergencyInfoWrapper,
  EmergencyInfoInnerWrapper,
  BodyWrapper,
} from "./styled"

export const EmergencyInformation = (): JSX.Element => {
  return (
    <EmergencyInfoWrapper>
      <EmergencyInfoInnerWrapper>
        <BodyWrapper>
          <p>
            Call <strong>911</strong> if you’re having a <br />
            mental health emergency
          </p>
        </BodyWrapper>
        <BodyWrapper>
          <p>
            Text <strong>Home</strong> to <strong>741-741</strong> if you're in
            emotional <br />
            distress and need immediate support
          </p>
        </BodyWrapper>
        <BodyWrapper>
          <p>
            Call or text <strong>988</strong> Suicide & <br />
            Crisis Lifeline. Chat service <br />
            is available at{" "}
            <a href="https://988lifeline.org">988lifeline.org</a>.
          </p>
        </BodyWrapper>
      </EmergencyInfoInnerWrapper>
    </EmergencyInfoWrapper>
  )
}
